interface Props {
  title: string;
  description: string;
  className?: string;
}

const TitleHeading = ({ title, description, className }: Props) => {
  return (
    <div className={className}>
      <h1 className="font-medium text-24">{title}</h1>
      <h2 className="text-14">{description}</h2>
    </div>
  );
};

export default TitleHeading;
